export const RESERVATION_STATUS_PENDING = "pending";
export const RESERVATION_STATUS_CONFIRMED = "confirmed";
export const RESERVATION_STATUS_DECLINED = "declined";

export const RESERVATION_STATUS = [
    RESERVATION_STATUS_PENDING,
    RESERVATION_STATUS_CONFIRMED,
    RESERVATION_STATUS_DECLINED,
];

export const RESERVATION_STATUS_USER_READABLE = {
    [RESERVATION_STATUS_PENDING]: "Attesa",
    [RESERVATION_STATUS_CONFIRMED]: "Confermata",
    [RESERVATION_STATUS_DECLINED]: "Rifiutata",
};

export const RESERVATION_STATUS_BADGES = {
    [RESERVATION_STATUS_PENDING]: "badge badge-warning",
    [RESERVATION_STATUS_CONFIRMED]: "badge badge-success",
    [RESERVATION_STATUS_DECLINED]: "badge badge-danger",
};

export const RESERVATION_STATUS_ACTIONS = [
    {
        status: RESERVATION_STATUS_CONFIRMED,
        label: "Conferma adesione",
        icon: "check",
        className: "btn btn-success btn-block mb-2",
        confirmMessage: "Vuoi confermare questa adesione?",
    },
    {
        status: RESERVATION_STATUS_DECLINED,
        label: "Rifiuta adesione",
        icon: "times",
        className: "btn btn-outline-danger btn-block mb-0",
        confirmMessage: "Vuoi rifiutare questa adesione?",
    },
];

export const getReservationStatusLabel = status => RESERVATION_STATUS_USER_READABLE[status] || status || "-";

export const getReservationStatusBadgeClassName = status => RESERVATION_STATUS_BADGES[status] || "badge badge-secondary";
